module.exports = __webpack_public_path__ + "img/icon_5_37.fa1edd49.png";